// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609110234/js/" + chunkId + "." + {"44":"e12c7e51","225":"3e77bbab","481":"e5da19bf","486":"73d5da0e","770":"511fa7b1"}[chunkId] + ".0.9767337654263845.chunk.js";
};